import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { MutationDetailsFragmentDoc } from '../../../project/project-detail/project-attendance/graphql/attendance.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConnectContactToCrediflowMutationVariables = Types.Exact<{
  contactId: Types.Scalars['Int'];
  partyId: Types.Scalars['Int'];
}>;


export type ConnectContactToCrediflowMutation = { __typename?: 'HyperionSchemaMutation', connectContactToCrediflowMutation?: { __typename?: 'Contact', mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export const ConnectContactToCrediflowDocument = gql`
    mutation ConnectContactToCrediflow($contactId: Int!, $partyId: Int!) {
  connectContactToCrediflowMutation(contactId: $contactId, partyId: $partyId) {
    mutationDetails {
      ...MutationDetails
    }
  }
}
    ${MutationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConnectContactToCrediflowGQL extends Apollo.Mutation<ConnectContactToCrediflowMutation, ConnectContactToCrediflowMutationVariables> {
    document = ConnectContactToCrediflowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }